export default __webpack_public_path__ + "static/media/LogoBeta.806e8f68.svg";